/* oxlint-disable import/export */
import { flagService } from '../../services/flagService';
import { getBillingFlagOverrides } from '../../settings/billingFlagOverrides';

// Re-export everything from the real @gonfalon/constants source.
//
// Through the package root, not through './constants'. rspack.config.ts aliases
// '@gonfalon/constants/constants' to this very file, so importing that subpath here would
// resolve back to this file and the re-export would be empty. The package root names the same
// module and no alias intercepts it, so this stays in sync with the real source without
// reaching across the workspace boundary by relative path.
export * from '@gonfalon/constants';

// Overrides: these take precedence over the wildcard re-export above.
// They add flagService-based fallbacks for when window.ldConstants isn't populated.

let globalIsLegacyPlan = false;

export function setLegacyPlanStatus(isLegacy: boolean): void {
  globalIsLegacyPlan = isLegacy;
}

export function hasLegacyPlan(): boolean {
  return globalIsLegacyPlan;
}

export const allClientSideFlags = (): { [key: string]: unknown } => {
  const flags = flagService.getAllClientSideFlags();
  const baseFlags = Object.keys(flags).length > 0 ? flags : window.ldConstants?.allClientSideFlags || {};
  return { ...baseFlags, ...getBillingFlagOverrides() };
};

export const accountId = () => {
  const config = flagService.getConfig();
  return config.accountId || window.ldConstants?.accountId || 'vitalstatistix-account';
};

export const baseUri = () => {
  const config = flagService.getConfig();
  return config.baseUri || window.ldConstants?.baseUri || window.location.origin;
};

export const clientSideId = () => {
  const config = flagService.getConfig();
  return config.clientSideId || window.ldConstants?.clientSideId || 'vitalstatistix-client-id';
};

export const assetBase = () => window.ldConstants?.assetBase || '/';
export const assetPath = () => window.ldConstants?.assetPath || '/assets';

export const backendVersion = () => {
  const config = flagService.getConfig();
  return config.backendVersion || window.ldConstants?.backendVersion || '1.0.0';
};

export const isSandbox = () => window.ldConstants?.isSandbox || false;
